<div class="entity-list-selector flex flex-column gap-md">
  <!-- Search Section -->
  @if (entities().length > 0) {
  <div class="search-section">
    <app-input [leadingIcon]="'search'" [trailingIcon]="'x'" [trailingIconHidden]="!searchTerm()"
      (trailingIconClick)="clearSearch()">
      <input type="text" [placeholder]="'entityList.search.placeholder' | translate" [(ngModel)]="searchTermValue"
        (input)="onSearchInput($event)" data-testid="entity-search-input" />
    </app-input>
  </div>
  }

  <!-- Show Inactive Filter -->
  @if (showInactiveFilter && entityConfig.inactiveField) {
  <div class="filter-bar" data-testid="filter-bar">
    <label class="show-inactive-label" data-testid="show-inactive-label">
      <input type="checkbox" [ngModel]="showInactive()" (ngModelChange)="showInactive.set($event)"
        data-testid="show-inactive-checkbox" />
      {{ 'entityList.showInactive' | translate }}
    </label>
  </div>
  }

  <!-- Loading State -->
  @if (loading()) {
  <div class="loading-container flex flex-column flex-align-center gap-md p-xl">
    <app-spinner></app-spinner>
    <p>{{ 'entityList.loading' | translate }}</p>
  </div>
  }

  <!-- Error State -->
  @else if (error()) {
  <div class="error-message flex flex-align-center gap-md p-lg m-md">
    <app-icon name="alert-circle" [color]="'var(--fg-danger)'" />
    <p>{{ error() }}</p>
  </div>
  }

  <!-- Empty State -->
  @else if (entities().length === 0) {
  <div class="empty-state flex flex-column flex-align-center gap-md p-xl">
    <app-icon name="folder" [size]="48" />
    <h3>{{ 'entityList.empty.title' | translate }}</h3>
    <p>{{ 'entityList.empty.description' | translate }}</p>
  </div>
  }

  <!-- Entity List -->
  @else {
  <div class="entity-list flex flex-column flex-grow">
    <!-- Select All Header (Multi-select mode only) -->
    @if (mode === 'multi' && filteredEntities().length > 0) {
    <div class="list-header flex flex-align-center flex-justify-space-between gap-md p-md">
      <app-checkbox class="ml-auto" [label]="'entityList.selectAll' | translate" [ngModel]="selectAllChecked()"
        (ngModelChange)="toggleSelectAll()" data-testid="select-all-checkbox" />
      <app-button variant="text" size="sm" (click)="selectVisible()" data-testid="select-visible-button">
        {{ 'entityList.selectVisible' | translate }}
      </app-button>
      <span class="selection-count">{{ 'entityList.selectionCount' | translate:{ count: selectedIds().size.toString() }
        }}</span>
    </div>
    }

    <!-- Entity Items -->
    @for (entity of filteredEntities(); track entity[entityConfig.idField]) {
    <!-- Custom Row Template -->
    @if (rowTemplate) {
    <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: entity }" />
    }
    <!-- Default Row Template -->
    @else {
    <div class="entity-item flex flex-align-center gap-md p-md" [class.selected]="isSelected(entity)"
      [class.inactive]="entityConfig.inactiveField && !entity[entityConfig.inactiveField]"
      (click)="selectEntity(entity)" [attr.data-testid]="'entity-item-' + entity[entityConfig.idField]" role="button"
      tabindex="0">

      <!-- Selection Column (only for multi-select mode) -->
      @if (mode === 'multi') {
      <div class="selection-column flex flex-align-center">
        <app-checkbox [ngModel]="isSelected(entity)" (ngModelChange)="toggleSelection(entity[entityConfig.idField])"
          (click)="$event.stopPropagation()" [attr.data-testid]="'checkbox-' + entity[entityConfig.idField]" />
      </div>
      }

      <!-- Entity Content -->
      <div class="entity-content clickable flex flex-align-center gap-md flex-grow" (click)="onEdit(entity, $event)"
        (keydown.enter)="onEdit(entity, $event)" (keydown.space)="onEdit(entity, $event)" role="button" tabindex="0">
        <div class="entity-icon">
          <app-icon name="folder" />
        </div>
        <div class="entity-details">
          <div class="entity-name-row">
            <h3>{{ entity[entityConfig.labelField] }}</h3>
            @if (entityConfig.inactiveField && !entity[entityConfig.inactiveField]) {
            <span class="inactive-badge" data-testid="inactive-badge">{{ 'entityList.inactive' | translate }}</span>
            }
          </div>
          @if (entityConfig.descriptionFn) {
          <p class="description">{{ entityConfig.descriptionFn(entity) }}</p>
          } @else if (entityConfig.descriptionField && entity[entityConfig.descriptionField]) {
          <p class="description">{{ entity[entityConfig.descriptionField] }}</p>
          }
        </div>
      </div>

      <!-- Actions Column -->
      @if (showActions) {
      <div class="actions-column flex gap-sm">
        <app-button variant="icon" (click)="onEdit(entity, $event)" [tippy]="'entityList.edit.tooltip' | translate"
          [attr.data-testid]="'edit-button-' + entity[entityConfig.idField]">
          <app-icon name="pencil" />
        </app-button>
        <app-button variant="icon" color="danger" (click)="onDelete(entity, $event)"
          [tippy]="'entityList.delete.tooltip' | translate"
          [attr.data-testid]="'delete-button-' + entity[entityConfig.idField]">
          <app-icon name="trash-2" />
        </app-button>
      </div>
      }
    </div>
    }
    }
  </div>

  <!-- No Search Results -->
  @if (filteredEntities().length === 0 && searchTerm()) {
  <div class="empty-state flex flex-column flex-align-center gap-md p-xl" data-testid="no-results-message">
    <app-icon name="search" [size]="48" />
    <h3>{{ 'entityList.noResults.title' | translate }}</h3>
    <p>{{ 'entityList.noResults.description' | translate }}</p>
    <app-button variant="outlined" (click)="clearSearch()">
      {{ 'entityList.noResults.clearButton' | translate }}
    </app-button>
  </div>
  }
  }
</div>